module.exports = __webpack_public_path__ + "static/media/epargn-login.e1d9c4b8.svg";